import 'react-datepicker/dist/react-datepicker.css';
import { TextStylesDesktop, Colors } from 'enums';
import styled, { css, createGlobalStyle } from 'styled-components';

export const CustomDatePickerStyles = css`
  .react-datepicker-popper {
    z-index: 4;
  }

  .react-datepicker {
    height: fit-content;
    box-shadow: 0px 4px 15px 4px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    border: none;

    &__month-container {
      width: 100%;
      height: 100%;
      padding: 20px;
    }

    &__tab-loop {
      position: absolute;
    }

    &__header {
      display: flex;
      flex-wrap: wrap;
      background: transparent;
      justify-content: center;
      padding: 0;
      border-bottom: none;
    }

    &__month {
      margin: 0;

      &--selecting-range {
        background: transparent;

        .react-datepicker__day {
          background: transparent !important;
        }
      }
    }

    &__day-names {
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 12px;
    }

    &__day-name {
      display: flex;
      align-items: center;
      justify-content: center;
      ${TextStylesDesktop.small1}
      color: ${Colors.gray2};
      margin: 0;
      width: 48px;
    }

    &__week {
      display: flex;
    }

    &__day {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      height: 48px;
      width: 48px;
      ${TextStylesDesktop.body}
      color: ${Colors.gray1};
      border-radius: 0;

      &::before {
        display: block;
        position: absolute;
        content: '';
        height: 40px;
        width: 100%;
        background: transparent;
      }

      .inner-day-sphere {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
      }

      &:first-child {
        border-radius: 16px 0px 0px 16px;
      }

      &:last-child {
        border-radius: 0px 16px 16px 0px;
      }

      &:hover {
        background: transparent;

        .inner-day-sphere {
          border-radius: 50% !important;
          color: white;
          background: ${Colors.gray3};
        }
      }

      &--selected {
        background: transparent;

        .inner-day-sphere {
          border-radius: 50% !important;
          background: ${Colors.yellow1};
        }
      }

      &--keyboard-selected {
        background: transparent;
      }

      &--outside-month {
        color: ${Colors.gray3};

        &.react-datepicker__day--in-range {
          color: white;
        }
      }

      &--in-range {
        background-color: transparent;

        &::before {
          background: ${Colors.gray4};
        }

        &:last-child {
          &::before {
            border-radius: 0 20px 20px 0;
          }
        }

        &:first-child {
          &::before {
            border-radius: 20px 0 0 20px;
          }
        }

        & > .last-month-day {
          &::before {
            border-radius: 0 20px 20px 0;
          }
        }
      }

      &--in-selecting-range {
        background: transparent !important;

        &:last-child {
          &::before {
            border-radius: 0 20px 20px 0;
          }
        }

        &:first-child {
          &::before {
            border-radius: 20px 0 0 20px;
          }
        }
      }

      &--selecting-range-start {
        .inner-day-sphere {
          background: ${Colors.yellow1};
          border-radius: 50%;
        }

        &::before {
          width: 50%;
          right: 0;
        }

        &:first-child {
          &::before {
            border-radius: 0;
          }
        }

        &:hover {
          &::before {
            background: transparent;
          }
        }
      }

      &--range-end {
        &::before {
          width: 50%;
          left: 0;
        }

        .inner-day-sphere {
          background: ${Colors.gray3};
          border-radius: 50%;
        }
      }

      &--range-start {
        &::before {
          width: 50%;
          right: 0;
        }
      }

      &--selecting-range-end {
        .inner-day-sphere {
          background: ${Colors.gray3};
          border-radius: 50%;
        }

        &::before {
          width: 50%;
          left: 0;
          border-radius: 0;
        }

        &:last-child {
          &::before {
            border-radius: 0;
          }
        }
      }

      &--disabled {
        color: ${Colors.gray4};

        &:hover {
          .inner-day-sphere {
            color: ${Colors.gray4};
            background: transparent;
            cursor: not-allowed;
          }
        }
      }
    }
  }
`;

export const DatePickerWrapper = styled.div`
  position: relative;
`;

export const DatePickerGlobalStyles = createGlobalStyle`
  ${CustomDatePickerStyles}
`;
